import { AsyncError, IAppFeedback } from '../../common';
import { createAction } from '../../utils/reduxUtils';

const sendFeedbackAsync = {
  request: createAction('@appFeedback/SEND_APPFEEDBACK_REQUEST')<IAppFeedback>,
  success: createAction('@appFeedback/SEND_APPFEEDBACK_SUCCESS')<void>,
  failure: createAction('@appFeedback/SEND_APPFEEDBACK_FAILURE')<AsyncError>,
};

const reset = createAction('@appFeedback/RESET')<void>;

const actions = {
  sendFeedbackAsync,
  reset,
};

export default actions;
